import "./App.css";
import HeroSection from "./components/HeroSection/HeroSection";
import Skills3 from "./components/Skills3";
import CornerGrid from "./components/CornerGrid";
import Experiences from "./components/experiences";
import Educations from "./components/educations";
import PortfolioProjects from "./components/PortfolioProjects";
import PublicContactSection from "../shared/public-contact-section";
import styled from "styled-components";

const SabriCanvas = styled.div`
  min-height: calc(100vh - 1rem);
  margin: 0.5rem;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 24px;
  background: #000;
  color: #fff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.16);
  isolation: isolate;

  @media (max-width: 768px) {
    min-height: calc(100vh - 0.5rem);
    margin: 0.25rem;
    border-radius: 18px;
  }
`;



function SabriTemplate({ data }) {
  return (
    <SabriCanvas>
      <CornerGrid/>
      <HeroSection profile={data?.profile} />
      <Skills3 skills={data?.skills} />
      <Experiences experiences={data?.experiences} />
      <Educations educations={data?.educations} />
      <PortfolioProjects projects={data?.projects} />
      <div style={{ backgroundColor: '#0a0a0a', padding: '4rem 2rem' }}>
        <PublicContactSection 
          profile={data?.profile}
          palette={{
            surface: 'transparent',
            card: 'rgba(255, 255, 255, 0.03)',
            input: 'rgba(255, 255, 255, 0.05)',
            border: 'rgba(255, 255, 255, 0.1)',
            text: '#ffffff',
            muted: 'rgba(255, 255, 255, 0.6)',
            iconBg: 'rgba(255, 255, 255, 0.05)',
            iconFg: '#fff',
            buttonBg: '#fff',
            buttonText: '#000',
          }}
        />
      </div>
    </SabriCanvas>
  );
}

export default SabriTemplate;
